import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Input.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import closeImg from '../../../assets/images/close-icon.png';
import boldImg from '../../../assets/images/bold-white-icon.png';
import italicImg from '../../../assets/images/italic-white-icon.png';
import codeImg from '../../../assets/images/code-white-icon.png';
import strikeImg from '../../../assets/images/strike-white-icon.png';
import underlineImg from '../../../assets/images/underline-white-icon.png';
import closeWhiteImg from '../../../assets/images/close-white-icon.png';
import phoneImg from '../../../assets/images/phone-icon.png';
import arrowImg from '../../../assets/images/arrow-down-white-icon.png';
import arrowUpImg from '../../../assets/images/arrow-up-white-icon.png';
import arrowDownPlusImg from '../../../assets/images/arrow-down-plus-white-icon.png';
import arrowUpPlusImg from '../../../assets/images/arrow-up-plus-white-icon.png';
import addPhoneImg from '../../../assets/images/add-phone-icon.png';
import addPersonImg from '../../../assets/images/add-person-icon.png';
import copyImg from '../../../assets/images/copy-white-icon.png';
import saveImg from '../../../assets/images/save-icon.png';
import phoneRingImg from '../../../assets/images/phone-ring-white-icon.png';
import emailImg from '../../../assets/images/email-icon.png';
import arrowRightImg from '../../../assets/images/arrow-down-white-icon.png';
import arrowDownImg from '../../../assets/images/arrow-down-icon.png';
import editImg from '../../../assets/images/edit-icon.png';
import plusOneImg from '../../../assets/images/plus-one-icon.png';
import deleteImg from '../../../assets/images/delete-icon.png';
import openImg from '../../../assets/images/open-white-icon2.png';
import plusImg from '../../../assets/images/plus-icon.png';
import mergeImg from '../../../assets/images/merge-white-icon.png';
import Button from '../Button/Button';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import LinkIcon from '../LinkIcon/LinkIcon';
import Spinner from '../Spinner/Spinner';
import * as actionTypes from '../../../store/actions';
import ButtonIconConfirm from '../ButtonIconConfirm/ButtonIconConfirm';
import Icon from '../Icon/Icon';

class Input extends Component {

  state = {
    options: this.props.elementConfig.options,
    optionsLen: this.props.elementConfig.options ? this.props.elementConfig.options.length : 0,
    displayOptions: false,
    searchText: '',
    localValue: null,
    localArray: [],
    typingTimeout: 0,
    dropdown: false
  }

  shouldComponentUpdate(nextProps, nextState) {
    let shouldUpdate = false;
    if (this.props.value !== nextProps.value ||
      this.props.elementConfig !== nextProps.elementConfig ||
      nextProps.elementConfig.length !== this.state.optionsLen) {
      shouldUpdate = true;
    }
    if (this.state.options !== nextState.options ||
      this.state.optionsLen !== nextState.optionsLen ||
      this.state.displayOptions !== nextState.displayOptions ||
      this.state.searchText !== nextState.searchText ||
      this.state.localValue !== nextState.localValue ||
      this.state.localArray !== nextState.localArray) {
      shouldUpdate = true;
    }
    return shouldUpdate;
  }

  formatDate(date) {
    if (date === undefined || date === null) {
      return "";
    }
    return date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(2, 4);
  }

  formatDateTime(date) {
    if (date === undefined || date === null) {
      return "";
    }
    return date.substring(11, 16) + " " + date.substring(8, 10) + "/" + date.substring(5, 7);
  }

  getTopMatches() {
    let limitOptions = 100;
    let options = [];
    for (let option in this.props.elementConfig.options) {
      if (this.props.elementConfig.options[option] !== null &&
        this.props.elementConfig.options[option] !== undefined &&
        this.props.elementConfig.options[option].displayValue !== null &&
        this.props.elementConfig.options[option].displayValue !== undefined &&
        this.props.elementConfig.options[option].displayValue.toUpperCase().indexOf(this.state.searchText.toUpperCase()) > -1) {
        options.push(this.props.elementConfig.options[option]);
      }

      if (options.length >= limitOptions) {
        break;
      }
    }
    return options.sort(function (a, b) { return a.displayValue > b.displayValue });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.elementConfig.options &&
      (this.props.elementConfig.options.length !== this.state.optionsLen || this.props.elementConfig.options !== prevProps.elementConfig.options)) {
      this.setState({
        options: this.props.elementConfig.options,
        optionsLen: this.props.elementConfig.options.length
      });
      this.findDisplay();
    }

    if (this.props.elementType === 'cars') {
      if (this.state.searchText === '' && this.props.value) {
        this.setState({ searchText: this.props.value ? this.props.value : "" });
      } else if (this.props.value !== prevProps.value) {
        this.findDisplay();
      }
    } else if (this.props.elementType === 'drivers' || this.props.elementType === 'carriers' || this.props.elementType === 'input-search') {

      if (this.state.searchText === '' && this.props.value !== prevProps.value) {
        this.findDisplay();
      } else if (this.props.value !== prevProps.value) {
        this.findDisplay();
      }
    }
  }

  findDisplay() {
    let display = "";
    for (let i = 0; i < this.props.elementConfig.options.length; i++) {
      if (this.props.elementConfig.options[i] && this.props.elementConfig.options[i].value === this.props.value) {
        display = this.props.elementConfig.options[i].displayValue;
        break;
      }
    }
    this.setState({ searchText: display ? display : "" });
  }

  componentDidMount() {
    switch (this.props.elementType) {
      case ('input-search'):
        this.setState({ localValue: this.props.value });
        this.findDisplay();
        if (this.props.elementConfig.displayOptions) {
          this.setState({ displayOptions: true });
        }
        break;
      case ('array-input-search'):
        if (this.props.value === null || this.props.value === undefined) {
          this.setState({ localArray: [] });
        } else {
          const valueArray = [...this.props.value];
          this.setState({ localArray: valueArray });
        }
        break;
      case ('cars'):
        this.setState({ localValue: this.props.value, searchText: this.props.value ? this.props.value : "" });
        break;
      case ('carriers'):
        this.setState({ localValue: this.props.value });
        this.findDisplay();
        break;
      case ('drivers'):
        this.setState({ localValue: this.props.value });
        this.findDisplay();
        break;
      default:
        break;
    }
  }

  getAttribute(carrier, attr) {
    if (carrier[attr]) {
      return carrier[attr];
    }
    return "";
  }

  render() {
    if (this.props.elementConfig.display === "none") {
      return null;
    }
    let inputElement = null;
    let inputClasses = [classes.InputElement];

    let validationError = null;
    if (this.props.invalid && this.props.shouldValidate) {
      inputClasses.push(classes.Invalid);
      validationError = <p className={classes.ValidationError}>{this.props.errorMessage}</p>;
    }

    let reset = (event, id) => {
      event.preventDefault();
      this.props.changed({ target: { value: null } });
      updateText({ target: { value: '' } });
    }

    let resetCarrier = (event, id) => {
      event.preventDefault();
      this.props.changed({ target: { value: null } });
      updateTextCarrier({ target: { value: '' } });
    }

    let updateText = (event) => {
      if (this.props.elementConfig.options.length <= 2 && this.props.extraAction) {
        if ("create" in this.props.extraAction) {
          this.props.extraAction.create();
        } else {
          this.props.extraAction();
        }
      }
      let filter = event.target.value.toUpperCase();
      let options = [];
      for (let option in this.props.elementConfig.options) {
        if (this.props.elementConfig.options[option].displayValue !== null && this.props.elementConfig.options[option].displayValue.toUpperCase().indexOf(filter) > -1) {
          options.push(this.props.elementConfig.options[option]);
        }

        if (!this.props.elementConfig.options[option].displayValue) {
          console.log(this.props.elementConfig.options[option]);
        }
      }
      this.setState({ searchText: event.target.value ? event.target.value : "", options: options });
    }

    let updateTextCarrier = (event) => {
      if (this.props.elementConfig.options.length <= 2 && this.props.extraAction) {
        this.props.extraAction.getCarriers();
      }
      let filter = event.target.value.toUpperCase();
      let options = [];
      for (let option in this.props.elementConfig.options) {
        if (this.props.elementConfig.options[option].displayValue !== null && this.props.elementConfig.options[option].displayValue.toUpperCase().indexOf(filter) > -1) {
          options.push(this.props.elementConfig.options[option]);
        }

        if (!this.props.elementConfig.options[option].displayValue) {
          console.log(this.props.elementConfig.options[option]);
        }
      }
      this.setState({ searchText: event.target.value ? event.target.value : "", options: options });
    }

    let updateTextCar = (event) => {
      if (this.props.elementConfig.options.length <= 2) {
        this.props.extraAction();
      }
      let filter = event.target.value.toUpperCase();
      let options = [];
      for (let option in this.props.elementConfig.options) {
        if (this.props.elementConfig.options[option].displayValue !== null && this.props.elementConfig.options[option].displayValue.toUpperCase().indexOf(filter) > -1) {
          options.push(this.props.elementConfig.options[option]);
        }

        if (!this.props.elementConfig.options[option].displayValue) {
          console.log("Something went wrong with " + option + " : ");
          console.log(this.props.elementConfig.options[option]);
        }
      }
      this.setState({ searchText: event.target.value ? event.target.value : "", options: options });
      this.props.changed({ target: { value: event.target.value, exist: true } });
    }

    let updateDatalist = (ev) => {
      if (this.props.elementConfig.options.length <= 2) {
        this.props.extraAction();
      }
      this.props.changed(ev);
    }

    let updateTextDriver = (event) => {
      if (this.props.elementConfig.options.length <= 2) {
        this.props.extraAction.create();
      }
      let filter = event.target.value.toUpperCase();
      let options = [];
      let foundValue = false;
      for (let option in this.props.elementConfig.options) {
        if (this.props.elementConfig.options[option] && this.props.elementConfig.options[option].displayValue && this.props.elementConfig.options[option].displayValue.toUpperCase().indexOf(filter) > -1) {
          options.push(this.props.elementConfig.options[option]);
        }

        if (!this.props.elementConfig.options[option] || !this.props.elementConfig.options[option].displayValue) {
          console.log("Something went wrong with " + option + " : ");
          console.log(this.props.elementConfig.options[option]);
        }

        if (this.props.elementConfig.options[option] &&
          this.props.elementConfig.options[option].displayValue &&
          this.props.elementConfig.options[option].displayValue.toUpperCase().trim() === event.target.value.toUpperCase().trim()) {
          this.props.changed({ target: { value: this.props.elementConfig.options[option].value } });
        }
      }

      this.setState({ searchText: event.target.value ? event.target.value : "", options: options });
    }

    let addToArray = (event) => {
      event.preventDefault();
      const updatedLocalArray = [...this.state.localArray];
      if (this.state.options.length == 0 && this.state.searchText !== '') {
        if (updatedLocalArray.indexOf(this.state.searchText) == -1) {
          updatedLocalArray.push(this.state.searchText);
          this.setState({ localArray: updatedLocalArray, searchText: '' });
          updateText({ target: { value: '' } });
        }
      } else {
        if (updatedLocalArray.indexOf(this.state.localValue) == -1) {
          updatedLocalArray.push(this.state.localValue);
          this.setState({ localArray: updatedLocalArray, localValue: null });
        }
      }

      this.props.changed({ target: { value: updatedLocalArray } });
    }

    let removeFromArray = (event, element) => {
      event.preventDefault();
      const updatedLocalArray = [...this.props.value];
      if (updatedLocalArray.indexOf(element) > -1) {
        updatedLocalArray.splice(updatedLocalArray.indexOf(element), 1);
        this.setState({ localArray: updatedLocalArray });
        this.props.changed({ target: { value: updatedLocalArray } });
      }
    }

    let addToCheckArray = (event) => {
      event.preventDefault();
      const updatedLocalArray = [...this.props.value];
      const values = [];
      updatedLocalArray.forEach((manager, i) => {
        values.push(manager.value);
      });

      if (this.state.options.length == 0 && this.state.searchText !== '') {
        if (values.indexOf(this.state.searchText) == -1) {
          updatedLocalArray.push({ value: this.state.searchText, checked: false });
          this.setState({ localArray: updatedLocalArray, searchText: '' });
          updateText({ target: { value: '' } });
        }
      } else {
        if (values.indexOf(this.state.localValue) == -1) {
          updatedLocalArray.push({ value: this.state.localValue, checked: false });
          this.setState({ localArray: updatedLocalArray, localValue: null });
        }
      }

      this.props.changed({ target: { value: updatedLocalArray } });
    }

    let inputSearchSelect = (event, value, display) => {
      event.preventDefault();
      this.setState({ displayOptions: false, searchText: display ? display : "" });
      updateText({ target: { value: display } });
      this.props.changed({ target: { value: value } });

    }
    let inputSelectCar = (event, value) => {
      event.preventDefault();
      this.setState({ displayOptions: false, searchText: value ? value : "" });
      updateText({ target: { value: value } });
      this.props.changed({ target: { value: value, exist: true } });
    }
    let inputSelectDriver = (event, value, display) => {
      event.preventDefault();
      this.setState({ displayOptions: false, searchText: display ? display : "" });
      updateText({ target: { value: display } });
      this.props.changed({ target: { value: value } });
    }
    let localValueSelect = (event, value) => {
      event.preventDefault();
      this.setState({ displayOptions: false, searchText: '', localValue: value });
      updateText({ target: { value: '' } });
    }

    let changedCheck = (event, managerName) => {
      event.preventDefault();
      const updatedLocalArray = [...this.props.value];

      updatedLocalArray.forEach((manager, index) => {
        console.log("Comparing " + manager.manager + " against " + managerName);
        if (manager.value === managerName) {
          updatedLocalArray[index] = {
            id: manager.id,
            manager: manager.manager,
            initiator: !manager.initiator,
            load: manager.load
          };
        } else {
          updatedLocalArray[index] = {
            id: manager.id,
            manager: manager.manager,
            initiator: false,
            load: manager.load
          };
        }
      });
      this.setState({ localArray: updatedLocalArray });
      this.props.changed({ target: { value: updatedLocalArray } });
    }

    let changedLoadLocal = (event, index) => {
      event.preventDefault();
      const updatedLocalArray = [...this.props.value];
      updatedLocalArray[index].load = event.target.value;
      this.props.changed({ target: { value: updatedLocalArray } });
    }

    let changeTripPoint = (event, index) => {
      event.preventDefault();
      const updatedPoints = [...this.props.value];
      let locations = Object.keys(this.props.locations);
      for (let i = 0; i < locations.length; i++) {
        if (parseInt(this.props.locations[locations[i]].id, 10) === parseInt(event.target.value, 10)) {
          updatedPoints[index].location = this.props.locations[locations[i]];
          break;
        }
      }
      this.props.changed({ target: { value: updatedPoints } });
    }

    let addLocation = (event) => {
      event.preventDefault();
      const updatedLocations = [...this.props.value];
      updatedLocations.push({ id: 0, location: "", region: 1 });
      this.props.changed({ target: { value: updatedLocations } });
    }

    let locationChanged = (event, index) => {
      event.preventDefault();
      const updatedLocations = [...this.props.value];
      updatedLocations[index].location = event.target.value;
      this.props.changed({ target: { value: updatedLocations } });
    }

    let userRoleChanged = (event, index) => {
      event.preventDefault();
      const updatedUsers = [...this.props.value];
      updatedUsers[index].role = event.target.value;
      this.props.changed({ target: { value: updatedUsers } });
    }

    let accountLockedChanged = (event, index) => {
      const updatedUsers = [...this.props.value];
      updatedUsers[index].locked = event.target.checked;
      this.props.changed({ target: { value: updatedUsers } });
    }

    let originatingLocationChanged = (event, index) => {
      const updated = [...this.props.value];
      updated[index].originatingLocation = event.target.checked;
      this.props.changed({ target: { value: updated } });
    }

    let changeAsteriskId = (event, index) => {
      const updatedUsers = [...this.props.value];
      updatedUsers[index].asteriskId = event.target.value;
      this.props.changed({ target: { value: updatedUsers } });
    }

    let changeMiniAsterisk = (event, index) => {
      const updatedUsers = [...this.props.value];
      updatedUsers[index].miniAsterisk = event.target.value;
      this.props.changed({ target: { value: updatedUsers } });
    }

    let changeManagerTbot = (event, index) => {
      const updatedManagers = [...this.props.value];
      updatedManagers[index].tbotId = event.target.value;
      this.props.changed({ target: { value: updatedManagers } });
    }

    let chatManagerChat = (event, index) => {
      const updatedManagers = [...this.props.value];
      updatedManagers[index].tbotChatId = event.target.value;
      this.props.changed({ target: { value: updatedManagers } });
    }

    let checkChecklist = (ev, index) => {
      const updatedChecklist = [...this.props.elementConfig.options];
      updatedChecklist[index].checked = ev.target.checked;
      this.props.changed({ target: { value: updatedChecklist } });
    }

    let changeManagerUser = (event, index) => {
      const updatedManagers = [...this.props.value];
      if (event.target.value === "-") {
        updatedManagers[index].username = null;
      } else {
        updatedManagers[index].username = event.target.value;
      }
      this.props.changed({ target: { value: updatedManagers } });
    }

    let regionChanged = (event, index) => {
      event.preventDefault();
      const updatedLocations = [...this.props.value];
      updatedLocations[index].region = parseInt(event.target.value);
      this.props.changed({ target: { value: updatedLocations } });
    }

    let changeOutcome = (event, index) => {
      event.preventDefault();
      const updatedTripCarrier = [...this.props.value];
      updatedTripCarrier[index].outcome = event.target.value;
      this.props.changed({ target: { value: updatedTripCarrier } });

      if (this.state.typingTimeout) {
        clearTimeout(this.state.typingTimeout);
      }
      const extraAction = this.props.extraAction.updateHistory;

      this.setState({
        typingTimeout: setTimeout(function () {
          extraAction(
            event,
            updatedTripCarrier[index].id,
            updatedTripCarrier[index].tripId,
            updatedTripCarrier[index].status,
            updatedTripCarrier[index].outcome,
            updatedTripCarrier[index].phoneNumber);
        }, 2500)
      });
    }

    let getId = (id) => {
      id = parseInt(id.toString().substring(1, id.length));
      if (id < 10) {
        return "00" + id;
      } if (id < 100) {
        return "0" + id;
      }

      if (id.length == 3) {
        return id;
      } else {
        return id.toString().substring(id.toString().length - 3, id.toString().length);
      }
    }

    let changeDropdown = (ev) => {
      ev.preventDefault();
      this.setState({ dropdown: !this.state.dropdown });
    }

    let changePhoneType = (event, index) => {
      event.preventDefault();
      const updatedTripCarrier = [...this.props.value];
      updatedTripCarrier[index].phoneType = event.target.value;
      delete updatedTripCarrier[index].active;
      this.props.changed({ target: { value: updatedTripCarrier } });
    }

    let changePhone = (event, index) => {
      event.preventDefault();
      const updatedTripCarrier = [...this.props.value];
      updatedTripCarrier[index].phoneNumber = event.target.value;
      this.props.changed({ target: { value: updatedTripCarrier } });
    }

    let addPhone = (event, carrier) => {
      event.preventDefault();
      const updatedTripCarrier = [...this.props.value];
      updatedTripCarrier.push({ carrier: carrier, phoneType: null, phoneNumber: "", active: true });
      this.props.changed({ target: { value: updatedTripCarrier } });
    }

    let changeStatus = (event, index) => {
      event.preventDefault();
      const updatedTripCarrier = [...this.props.value];
      updatedTripCarrier[index].status = event.target.value;
      this.props.changed({ target: { value: updatedTripCarrier } });
      this.props.extraAction.updateHistory(
        event,
        updatedTripCarrier[index].id,
        updatedTripCarrier[index].tripId,
        updatedTripCarrier[index].status,
        updatedTripCarrier[index].outcome,
        updatedTripCarrier[index].phoneNumber);
    }

    let copyToClipboard = (ev, id, message) => {
      ev.preventDefault();
      document.getElementById(id).select();
      document.execCommand("copy");
      this.props.addNotification(message, "Success");
    }

    let roundNum = (num) => {
      return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
    }

    let changePhoneNumber = (event, index) => {
      event.preventDefault();
      const updatedTripCarrier = [...this.props.value];
      updatedTripCarrier[index].phoneNumber = event.target.value;
      this.props.changed({ target: { value: updatedTripCarrier } });

      if (this.state.typingTimeout) {
        clearTimeout(this.state.typingTimeout);
      }

      const extraAction = this.props.extraAction.updateHistory;

      this.setState({
        typingTimeout: setTimeout(function () {
          extraAction(
            event,
            updatedTripCarrier[index].id,
            updatedTripCarrier[index].tripId,
            updatedTripCarrier[index].status,
            updatedTripCarrier[index].outcome,
            updatedTripCarrier[index].phoneNumber);
        }, 2500)
      });
    }

    let managerAccepted = (event, index) => {
      const updatedManagerChecked = [...this.props.value];
      updatedManagerChecked[index].accepted = event.target.checked;
      this.props.changed({ target: { value: updatedManagerChecked } });
    }

    let unloadAfter = (event, index) => {
      const updatedManagerChecked = [...this.props.value];
      updatedManagerChecked[index].unloadAfter = event.target.checked;
      this.props.changed({ target: { value: updatedManagerChecked } });
    }

    let getOptions = () => {
      let phones = ["Тип Телефона", "Телефоны", "ЮлК1Т1", "ЮлК1Т2", "ЮлК2Т1", "ЮлК2Т2", "ЛСК1Т1", "ЛСК1Т2", "ЛСК2Т1", "ЛСК2Т2", "Партнер_Телефоны"];
      for (let i = 0; i < this.props.value.length; i++) {
        if (phones.includes(this.props.value[i].phoneType)) {
          phones.splice(phones.indexOf(this.props.value[i].phoneType), 1);
        }
      }

      return phones.map(phone => {
        return (
          <option key={phone} value={phone}>
            {phone}
          </option>);
      });
    }

    switch (this.props.elementType) {
      case ('display-only'):
        inputElement = (
          <p>{this.props.value}</p>
        );
        break;
      case ('display-copy'):
        let element = (
          <input
            id="manager-link"
            {...this.props.elementConfig}
            className={inputClasses.join(' ')}
            value={this.props.value} />
        );
        if (this.props.elementConfig.type && this.props.elementConfig.type === "textarea") {
          element = (
            <textarea
              id="manager-link"
              {...this.props.elementConfig}
              className={inputClasses.join(' ')}
              value={this.props.value} />
          );
        }
        inputElement = (
          <Aux>
            {element}
            <ButtonIcon
              btnType='Success'
              clicked={(ev) => copyToClipboard(ev, "manager-link", "Скопировал ссылку менеджера.")}
              iconClass={classes.ButtonIcon}
              iconSource={copyImg}
              small
              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
              iconAlt=''></ButtonIcon>
          </Aux>
        );
        break;
      case ('input'):
        inputElement = <input
          key={this.props.elementConfig.animate}
          className={inputClasses.join(' ')}
          {...this.props.elementConfig}
          value={this.props.value}
          onChange={this.props.changed} />;
        break;
      case ('email'):
        inputClasses.push(classes.InlineEmail)
        inputElement = (
          <Aux>
            <input
              className={inputClasses.join(' ')}
              {...this.props.elementConfig}
              value={this.props.value}
              onChange={this.props.changed} />
            <div className={classes.Email}>
              @ufc.dp.ua
            </div>
          </Aux>
        );
        break;
      case ('textarea'):
        inputElement = <textarea
          key={this.props.elementConfig.animate}
          className={inputClasses.join(' ')}
          id={this.props.elementConfig.id ? this.props.elementConfig.id : null}
          {...this.props.elementConfig}
          value={this.props.value}
          onChange={this.props.changed} />
        break;
      case ('telegram-message'):
        inputElement = (
          <Aux>
            <div className={classes.TelegramButtonHolder}>
              <ButtonIcon
                btnType='Neutral'
                btnClass={classes.InlineButton}
                clicked={
                  (ev) => this.props.changed(
                    {
                      target: {
                        value: this.props.extraAction.updateText(
                          document.getElementById("telegram-message"),
                          "b"
                        )
                      }
                    }
                  )
                }
                iconClass={classes.UpdateTextIcon}
                iconSource={boldImg}
                iconAlt=''></ButtonIcon>
              <ButtonIcon
                btnType='Neutral'
                btnClass={classes.InlineButton}
                clicked={
                  (ev) => this.props.changed(
                    {
                      target: {
                        value: this.props.extraAction.updateText(
                          document.getElementById("telegram-message"),
                          "i"
                        )
                      }
                    }
                  )
                }
                iconClass={classes.UpdateTextIcon}
                iconSource={italicImg}
                iconAlt=''></ButtonIcon>
              <ButtonIcon
                btnType='Neutral'
                btnClass={classes.InlineButton}
                clicked={
                  (ev) => this.props.changed(
                    {
                      target: {
                        value: this.props.extraAction.updateText(
                          document.getElementById("telegram-message"),
                          "u"
                        )
                      }
                    }
                  )
                }
                iconClass={classes.UpdateTextIcon}
                iconSource={underlineImg}
                iconAlt=''></ButtonIcon>
              <ButtonIcon
                btnType='Neutral'
                btnClass={classes.InlineButton}
                clicked={
                  (ev) => this.props.changed(
                    {
                      target: {
                        value: this.props.extraAction.updateText(
                          document.getElementById("telegram-message"),
                          "s"
                        )
                      }
                    }
                  )
                }
                iconClass={classes.UpdateTextIcon}
                iconSource={strikeImg}
                iconAlt=''></ButtonIcon>
              <ButtonIcon
                btnType='Neutral'
                btnClass={classes.InlineButton}
                clicked={
                  (ev) => this.props.changed(
                    {
                      target: {
                        value: this.props.extraAction.updateText(
                          document.getElementById("telegram-message"),
                          "code"
                        )
                      }
                    }
                  )
                }
                iconClass={classes.UpdateTextIcon}
                iconSource={codeImg}
                iconAlt=''></ButtonIcon>
            </div>
            <textarea
              key={this.props.elementConfig.animate}
              className={inputClasses.join(' ')}
              id={this.props.elementConfig.id ? this.props.elementConfig.id : null}
              {...this.props.elementConfig}
              value={this.props.value}
              onChange={this.props.changed} />
          </Aux>
        )
        break;
      case ('select'):
        inputElement = (<select
          className={inputClasses.join(' ')}
          value={this.props.value}
          key={this.props.elementConfig.animate}
          onChange={this.props.changed} >
          {this.props.elementConfig.options.map(option => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>)
        break;
      case ('checklist'):
        inputElement = (<div
          className={inputClasses.join(' ')}
          key={this.props.elementConfig.animate}>
          {this.props.elementConfig.options.map((option, index) => (
            <Aux>
              <label style={{ width: "auto", display: "inline-block" }}>
                {option.displayValue}
              </label>
              <input type="checkbox" key={option.value} checked={option.checked} onChange={(ev) => checkChecklist(ev, index)} />
              {
                option.extra &&
                <label style={{ width: "auto", display: "inline-block" }}>
                  {option.extra}
                </label>
              }
              <br />
            </Aux>
          ))}
        </div>)
        break;
      case ('trip-points'):
        let points = (
          this.props.value.map((tripPoint, index) => {
            return (
              <Aux>
                {this.state.dropdown ?
                  <div className={classes.LocationHolder}>
                    <select
                      className={[...inputClasses, classes.SelectLocation].join(' ')}
                      value={tripPoint.location.id}
                      key={this.props.elementConfig.animate + " " + index}
                      onChange={(ev) => changeTripPoint(ev, index)} >
                      {this.props.elementConfig.options.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.displayValue}
                        </option>
                      ))}
                    </select>
                    <div className={classes.SelectButtonHolder}>
                      <ButtonIcon
                        btnType='Gray'
                        btnClass={classes.ButtonNoMargin}
                        clicked={(ev) => this.props.extraAction.moveUp(ev, index)}
                        iconClass={classes.UpIcon}
                        iconSource={arrowDownImg}
                        iconAlt=''></ButtonIcon>
                      <ButtonIcon
                        btnType='Gray'
                        btnClass={classes.ButtonNoMargin}
                        clicked={(ev) => this.props.extraAction.moveDown(ev, index)}
                        iconClass={classes.DownIcon}
                        iconSource={arrowDownImg}
                        iconAlt=''></ButtonIcon>
                      <ButtonIcon
                        btnType='Danger'
                        clicked={(ev) => this.props.extraAction.deletePoint(ev, index)}
                        iconClass={classes.ButtonIcon}
                        iconSource={deleteImg}
                        style={{ marginLeft: "0", marginRight: "0" }}
                        iconAlt=''></ButtonIcon>
                    </div>
                  </div>
                  : null}
              </Aux>
            );
          })
        );
        inputElement = (
          <Aux>
            <button
              className={classes.DropdownButton}
              onClick={(ev) => changeDropdown(ev)}>
              <img
                src={this.props.elementConfig.buttonImgSrc}
                alt=''
                className={classes.DropdownListIcon} />
              Маршрут
              <img className={classes.DropdownArrow} src={arrowRightImg} alt='' />
            </button>
            {this.state.dropdown ?
              <ButtonIcon
                btnType='Success'
                clicked={(ev) => this.props.extraAction.addPoint(ev)}
                iconClass={classes.ButtonIcon}
                iconSource={plusOneImg}
                small
                style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                iconAlt=''></ButtonIcon>
              : null}
            {points}
          </Aux>
        )
        break;
      case ('drivers'):
        inputElement = (
          <Aux>
            <ButtonIcon
              btnType='Success'
              clicked={(ev) => this.props.extraAction.openNew(ev)}
              iconClass={classes.ButtonIcon}
              iconSource={plusOneImg}
              small
              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
              iconAlt=''></ButtonIcon>
            <ButtonIcon
              btnType='Success'
              clicked={(ev) => this.props.extraAction.open(ev)}
              iconClass={classes.ButtonIcon}
              iconSource={openImg}
              small
              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
              iconAlt=''></ButtonIcon>
            <ButtonIconConfirm
              btnType='Danger'
              clicked={(ev) => this.props.extraAction.delete(ev)}
              iconClass={classes.ButtonIcon}
              iconSource={deleteImg}
              small
              confirmText={'пометить водителя в Мани на удаление'}
              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
              iconAlt=''></ButtonIconConfirm>
            <div
              className={[...inputClasses, classes.CompositeElement].join(' ')}>
              <input
                type="text"
                className={classes.CompositeInput}
                placeholder="Пошук..."
                id='drivers'
                key={this.props.elementConfig.animate}
                onChange={updateTextDriver}
                onClick={updateTextDriver}
                autocomplete="off"
                value={this.state.searchText}
                onFocus={() => this.setState({ displayOptions: true })} />
              <button
                className={classes.CompositeButton}
                onClick={(ev) => reset(ev, "drivers")}>
                <img src={closeImg} className={classes.CompositeIcon} />
              </button>
            </div>
            {this.props.loading ?
              <Spinner fontSize="3px" />
              :
              <div
                className={inputClasses.join(' ')}
                style={{ display: this.state.displayOptions ? "block" : "none", width: "auto" }}>
                {this.getTopMatches().map(option => (
                  <button
                    key={option.value}
                    value={option.value}
                    className={this.props.value === option.value ? classes.InputSearchButton + "  " + classes.active : classes.InputSearchButton}
                    onClick={(event) => inputSelectDriver(event, option.value, option.displayValue)}>
                    {option.displayValue}
                  </button>
                ))}
              </div>}
          </Aux>
        );
        break;
      case ('list'):
        inputElement = (<ul>
          {this.props.elementConfig.options.length > 0 ?
            this.props.elementConfig.options.map(element => (
              <li>
                {element}
              </li>
            )) : <p>Пустой список.</p>}
        </ul>)
        break;
      case ('dropdown-list'):
        let dropdownEl = (
          <ul className={[classes.DropdownList, this.state.dropdown ? classes.full : null].join(' ')}>
            {this.props.elementConfig.options.length > 0 ?
              this.props.elementConfig.options.map(element => (
                <li>
                  {element}
                </li>
              )) : <p>Пустой список.</p>}
          </ul>);
        inputElement = (<Aux>
          <button
            className={classes.DropdownButton}
            onClick={() => this.setState({ dropdown: !this.state.dropdown })}>
            <img
              src={this.props.elementConfig.buttonImgSrc}
              alt=''
              className={classes.DropdownListIcon} />
            {this.props.value}
            <img className={classes.DropdownArrow} src={arrowRightImg} alt='' />
          </button>
          {dropdownEl}
        </Aux>)
        break;
      case ('action'):
        inputElement = <Aux> {this.props.value} </Aux>;
        break;
      case ('trip-carrier-history'):
        let addOneButton = null;
        if (this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER') {
          addOneButton = (
            <ButtonIcon
              btnType='Success'
              clicked={(ev) => this.props.extraAction.blankHistoryRecord(ev)}
              iconClass={classes.ButtonIcon}
              iconSource={plusOneImg}
              small
              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
              iconAlt=''></ButtonIcon>
          );
        }
        inputElement = (
          <Aux>
            {addOneButton}
            <ul>
              {this.props.value.length > 0 ?
                this.props.value.map((element, index) => {
                  let source = (
                    <input
                      className={[...inputClasses, classes.InputDisabled].join(' ')}
                      type='text'
                      value={element.phoneNumber}
                      style={{ width: "20%" }}
                      disabled />
                  );
                  let isEmail = false;
                  if (element.customisable) {
                    source = (
                      <input
                        className={[...inputClasses].join(' ')}
                        type='text'
                        disabled={this.props.role !== 'ROLE_ADMIN' && this.props.role !== 'ROLE_DISPATCHER'}
                        onChange={(ev) => changePhoneNumber(ev, index)}
                        value={element.phoneNumber}
                        style={{ width: "20%" }} />
                    );
                    if (element.phoneNumber.indexOf('@') > -1) {
                      isEmail = true;
                    }
                  }
                  let disabledInput = element.customisable ? {} : { "disabled": "disabled" };
                  return (
                    <li
                      key={element.name + " " + index}
                      className={classes.TripCarrierHistory}>
                      <input
                        className={[...inputClasses, classes.InputDisabled].join(' ')}
                        type='text'
                        value={element.name}
                        style={{ width: "62.5%", fontSize: "12px" }}
                        disabled />
                      {source}
                      <select
                        className={inputClasses.join(' ')}
                        value={element.status}
                        style={{ width: "20%" }}
                        disabled={this.props.role !== 'ROLE_ADMIN' && this.props.role !== 'ROLE_DISPATCHER'}
                        onChange={(ev) => changeStatus(ev, index)} >
                        <option key="-" value="-">-</option>
                        <option key="не_отвечает" value="Не Отвечает">Не Отвечает</option>
                        <option key="занято" value="Занято">Занято</option>
                        <option key="ответил" value="Ответил">Ответил</option>
                      </select>
                      <input
                        className={inputClasses.join(' ')}
                        type='text'
                        value={element.outcome}
                        style={{ width: "40%" }}
                        disabled={this.props.role !== 'ROLE_ADMIN' && this.props.role !== 'ROLE_DISPATCHER'}
                        onChange={(ev) => changeOutcome(ev, index)} />
                      {
                        element.customisable && this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER'
                          ?
                          isEmail && this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER' ?
                            <LinkIcon
                              btnType='Success'
                              link={"mailto:" + element.phoneNumber.trim()}
                              iconClass={classes.ButtonIcon}
                              iconSource={emailImg}
                              small
                              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                              iconAlt=''></LinkIcon>
                            : null
                          :
                          this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER' ?
                            <ButtonIcon
                              btnType='Success'
                              clicked={(ev) => this.props.extraAction.call(ev, element.name, element.phoneType, element.phoneNumber)}
                              iconClass={classes.ButtonIcon}
                              iconSource={phoneImg}
                              small
                              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                              iconAlt=''></ButtonIcon>
                            : null
                      }

                      {this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER' ?
                        <Aux>
                          <ButtonIcon
                            btnType='Success'
                            clicked={(ev) => this.props.extraAction.copyHistoryRecord(ev, element.name)}
                            iconClass={classes.ButtonIcon}
                            iconSource={copyImg}
                            small
                            style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                            iconAlt=''></ButtonIcon>
                          <ButtonIcon
                            btnType='Danger'
                            clicked={(ev) => this.props.extraAction.delete(ev, index)}
                            iconClass={classes.ButtonIcon}
                            iconSource={deleteImg}
                            small
                            style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                            iconAlt=''></ButtonIcon>
                        </Aux>
                        : null}
                    </li>
                  );
                })
                : <p>Нет историй обращения к перевозчикам.</p>}
            </ul>
          </Aux>
        );
        break;
      case ('phones'):
        inputElement = (
          <ul>
            {this.props.value.length > 0 ?
              this.props.value.map((element, index) => {
                let carrierName = "";
                for (let i = 0; i < this.props.carriers.length; i++) {
                  let carrier = this.props.carriers[i];
                  if (parseInt(carrier.id) === parseInt(element.carrier)) {
                    carrierName += carrier.id <= 0 ? " " : carrier.id + " | ";
                    carrierName += this.getAttribute(carrier, "okpo") + " | ";
                    carrierName += this.getAttribute(carrier, "name") + " | ";
                    carrierName += this.getAttribute(carrier, "name_partner") + " | ";
                    carrierName += this.getAttribute(carrier, "name_ls");
                    break;
                  }
                }
                return (
                  <li
                    key={element.phoneType + " " + index}
                    className={classes.PhoneElement}>
                    {element.active ?
                      <select
                        className={[classes.InputElement, classes.InputElementInline].join(' ')}
                        value={element.phoneType}
                        onChange={(ev) => changePhoneType(ev, index)}
                        style={{ width: "auto", marginLeft: "0", paddingRight: "14px" }}
                        disabled={element.active ? null : true} >
                        {getOptions()}
                      </select>
                      : <input
                        className={inputClasses.join(' ')}
                        type='text'
                        value={element.phoneType}
                        disabled
                        style={{ width: "auto" }} />}
                    <input
                      className={inputClasses.join(' ')}
                      type='text'
                      value={element.phoneNumber}
                      onChange={(ev) => changePhone(ev, index)}
                      style={{ width: "auto" }} />
                    <ButtonIcon
                      btnType='Success'
                      clicked={(ev) => this.props.extraAction.savePhone(ev, element.carrier, element.phoneType, element.phoneNumber)}
                      iconClass={classes.ButtonIcon}
                      iconSource={saveImg}
                      small
                      style={{ width: "auto", display: "inline-block" }}
                      iconAlt=''></ButtonIcon>
                    <ButtonIcon
                      btnType='Success'
                      clicked={(ev) => this.props.extraAction.call(ev, carrierName, element.phoneType, element.phoneNumber)}
                      iconClass={classes.ButtonIcon}
                      iconSource={phoneImg}
                      small
                      style={{ width: "auto", display: "inline-block" }}
                      iconAlt=''></ButtonIcon>
                  </li>)
              }) : <p>Нет телефонов.</p>}
            {this.props.value.length > 0 ?
              <ButtonIcon
                btnType='Success'
                clicked={(ev) => addPhone(ev, this.props.value[0].carrier)}
                iconClass={classes.ButtonIcon}
                iconSource={addPhoneImg}
                small
                style={{ width: "auto", display: "inline-block" }}
                iconAlt=''></ButtonIcon>
              : null}
          </ul>)
        break;
      case ('driver-phones'):
        inputElement = (
          <ul>
            {this.props.value.length > 0 ?
              this.props.value.map((element, index) => {
                return (
                  <li
                    key={index}
                    className={classes.PhoneElement}>
                    <input
                      className={inputClasses.join(' ')}
                      type='text'
                      disabled
                      value={element.phone}
                      style={{ width: "auto" }} />
                    {this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER' ?
                      <ButtonIcon
                        btnType='Success'
                        clicked={(ev) => this.props.extraAction.call(ev, element.name, "Водитель", element.phone)}
                        iconClass={classes.ButtonIcon}
                        iconSource={phoneImg}
                        small
                        style={{ width: "auto", display: "inline-block" }}
                        iconAlt=''></ButtonIcon>
                      : null}
                  </li>)
              }) : <p>Нет телефонов.</p>}
          </ul>)
        break;
      case ('toggle-switch'):
        let checked = {};
        if (this.props.value) {
          checked["checked"] = true;
        }
        inputElement = (
          <label className={classes.Switch}>
            <input
              type="checkbox"
              key={this.props.elementConfig.animate}
              {...checked}
              onChange={(ev) => this.props.changed({ target: { value: ev.target.checked } })}
              className={[classes.SwitchInput, classes.SliderInput, classes.Round].join(' ')} />
            <span className={classes.Slider}></span>
          </label>
        )
        break;
      case ('input-search'):
        inputElement = (
          <Aux>
            <div
              className={[...inputClasses, classes.CompositeElement].join(' ')}>
              <input
                type="text"
                className={classes.CompositeInput}
                placeholder="Пошук..."
                key={this.props.elementConfig.animate}
                id={this.state.searchText}
                onChange={updateText}
                onClick={updateText}
                value={this.state.searchText}
                onFocus={() => this.setState({ displayOptions: true })} />
              <button
                className={classes.CompositeButton}
                onClick={(ev) => reset(ev, this.state.searchText)}>
                <img src={closeImg} className={classes.CompositeIcon} />
              </button>
            </div>
            {this.props.loading ?
              <Spinner fontSize="3px" />
              :
              <div
                className={inputClasses.join(' ')}
                style={{ display: this.state.displayOptions ? "block" : "none" }}>
                {this.state.options.map((option, index) => (
                  <button
                    key={index}
                    value={option.value}
                    className={this.props.value === option.value ? classes.InputSearchButton + "  " + classes.active : classes.InputSearchButton}
                    onClick={(event) => inputSearchSelect(event, option.value, option.displayValue)}
                    style={{ display: this.state.displayOptions ? "block" : "none" }}>
                    {option.displayValue}
                  </button>
                ))}
              </div>}
          </Aux>
        );
        break;
      case ('datalist'):
        inputElement = (
          <Aux>
            <input
              list={this.props.elementConfig.list}
              name={this.props.elementConfig.list}
              value={this.props.value}
              key={this.props.elementConfig.animate}
              autocomplete="off"
              style={{ display: "inline-block", padding: "6px 10px", width: "auto" }}
              className={inputClasses.join(' ')}
              onClick={(ev) => updateDatalist(ev)}
              onChange={(ev) => updateDatalist(ev)}></input>
            {this.props.loading ?
              <Spinner fontSize="3px" />
              :
              <datalist
                className={inputClasses.join(' ')}
                value={this.props.value}
                autocomplete="off"
                id={this.props.elementConfig.list}
                style={{ display: "none" }}
                onClick={(ev) => updateDatalist(ev)}
                onChange={(ev) => updateDatalist(ev)} >
                {this.props.elementConfig.options.map(option => (
                  <option key={option.value} value={option.value} />
                ))}
              </datalist>}
          </Aux>)
        break;
      case ('cars'):
        inputElement = (
          <Aux>
            <div
              className={[...inputClasses, classes.CompositeElement].join(' ')}>
              <input
                type="text"
                className={classes.CompositeInput}
                key={this.props.elementConfig.animate}
                placeholder="Пошук..."
                autocomplete="off"
                id='cars'
                onChange={updateTextCar}
                onClick={updateTextCar}
                value={this.state.searchText}
                onFocus={() => this.setState({ displayOptions: true })} />
              <button
                className={classes.CompositeButton}
                onClick={(ev) => reset(ev, 'cars')}>
                <img src={closeImg} className={classes.CompositeIcon} />
              </button>
            </div>
            {this.props.loading ?
              <Spinner fontSize="3px" />
              :
              <div
                className={inputClasses.join(' ')}
                style={{ display: this.state.displayOptions ? "block" : "none" }}>
                {this.getTopMatches().map(option => (
                  <button
                    key={option.value}
                    value={option.value}
                    className={this.props.value === option.value ? classes.InputSearchButton + "  " + classes.active : classes.InputSearchButton}
                    onClick={(event) => inputSelectCar(event, option.value)}>
                    {option.displayValue}
                  </button>
                ))}
              </div>}
          </Aux>
        );
        break;
      case ('carriers'):
        let addCarrierButton = null;
        if (this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER') {
          addCarrierButton = (
            <button
              className={classes.CompositeButton}
              onClick={(ev) => resetCarrier(ev, 'carriers')}>
              <img src={closeImg} className={classes.CompositeIcon} />
            </button>
          );
        }
        inputElement = (
          <Aux>
            <div
              className={[...inputClasses, classes.CompositeElement].join(' ')}>
              <input
                type="text"
                className={classes.CompositeInput}
                key={this.props.elementConfig.animate}
                placeholder="Пошук..."
                id='carriers'
                autocomplete="off"
                onChange={updateTextCarrier}
                onClick={updateTextCarrier}
                value={this.state.searchText}
                onFocus={() => this.setState({ displayOptions: true })} />
              {addCarrierButton}
            </div>
            {this.props.loading ?
              <Spinner fontSize="3px" />
              :
              <div
                className={inputClasses.join(' ')}
                style={{ display: this.state.displayOptions ? "block" : "none" }}>
                {this.state.options.map(option => (
                  <button
                    key={option.value}
                    value={option.value}
                    className={this.props.value === option.value ? classes.InputSearchButton + "  " + classes.active : classes.InputSearchButton}
                    onClick={(event) => inputSearchSelect(event, option.value, option.displayValue)}>
                    {option.displayValue}
                  </button>
                ))}
              </div>}
          </Aux>
        );
        break;
      case ('array-input-search'):
        inputElement = (
          <Aux>
            <div className={classes.ArrayAdd}>
              <input
                type="text"
                className={inputClasses.join(' ')}
                placeholder="Пошук..."
                key={this.props.elementConfig.animate}
                onChange={updateText}
                onClick={updateText}
                value={this.state.searchText}
                onFocus={() => this.setState({ displayOptions: true })} />
              <Button btnType="Success" clicked={(event) => addToArray(event)}>ДОБАВИТЬ</Button>
            </div>
            <div
              className={inputClasses.join(' ')}>
              {this.state.options.map(option => (
                <button
                  key={option.value}
                  value={option.value}
                  className={this.state.localValue === option.value ? classes.InputSearchButton + "  " + classes.active : classes.InputSearchButton}
                  onClick={(event) => localValueSelect(event, option.value)}
                  style={{ display: this.state.displayOptions || this.state.localValue === option.value ? "block" : "none" }}>
                  {option.displayValue}
                </button>
              ))}
              <ul>
                {this.state.localArray.length > 0 ?
                  this.state.localArray.map(element => (
                    <li>
                      {element}
                      <button
                        className={classes.CloseButtonInline}
                        onClick={(ev) => removeFromArray(ev, element)}>
                        <Icon iconClass={classes.CloseIconSmall} iconSource={closeImg} iconAlt='' />
                      </button>
                    </li>
                  )) : <p>Нет элементов в списке. Выберите элемент и нажмите 'Добавить'.</p>}
              </ul>
            </div>
          </Aux>
        );
        break;
      case ('managers'):
        let extraButton = null;
        if (this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER') {
          extraButton = (
            <ButtonIconConfirm
              btnType='Success'
              clicked={(ev) => this.props.extraAction.telegramConfirmPrice(ev)}
              iconClass={classes.ButtonIcon}
              iconSource={phoneRingImg}
              confirmText={'запросить подтверждение цены:\n' + this.props.extraAction.generateTelegramMessage()}
              small
              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
              iconAlt=''>ЗАПИТАТИ ПІДТВЕРДЖЕННЯ ЦІНИ</ButtonIconConfirm>
          );
        }
        inputElement = (
          <Aux>
            {extraButton}
            <div
              className={inputClasses.join(' ')}
              style={{ width: "100%", padding: "0" }}>
              <ul className={classes.ListNoBullet}>
                <li className={[classes.ListNoBulletElement, classes.ListNoBulletHeading].join(' ')}>
                  <p style={{ width: "25%" }}>Менеджер</p><p style={{ width: "15%" }}>Заявлено Всього</p><p style={{ width: "20%" }}>Ціна Прийнята</p><p style={{ width: "40%" }}>Останній Відповідь</p>
                </li>
                {this.props.value.length > 0 ?
                  this.props.value.map((element, index) => {

                    return (
                      <li
                        className={[classes.Option, classes.ListNoBulletElement].join(' ')}
                        key={index}>
                        <p style={{ width: "25%", margin: "0" }}>{element.manager}</p>
                        <input
                          type="number"
                          step="0.01"
                          min="0.1"
                          placeholder="Заявлено"
                          value={roundNum(element.load)}
                          disabled
                          style={{ width: "15%", margin: "0" }}
                          className={[classes.InputElement, classes.InputElementInline, classes.InputDisabled].join(' ')} />
                        <div style={{ width: "20%", display: "inline-block", margin: "0" }}>
                          <label className={classes.Switch}>
                            <input
                              type="checkbox"
                              value=""
                              checked={element.accepted}
                              onChange={(ev) => managerAccepted(ev, index)}
                              className={[classes.SwitchInput, classes.SliderInput, classes.Round].join(' ')} />
                            <span className={classes.Slider}></span>
                          </label>
                        </div>
                        {element.lastMessage ?
                          <p
                            style={{ width: "40%", margin: "0" }}
                            className={classes.ManagerMessage}>
                            {element.lastMessage} - цена {element.lastPrice} ({this.formatDateTime(element.lastMessageDate)})
                          </p>
                          : null}
                      </li>
                    );
                  }) : <p className={classes.EmptyList}>Немає менеджерів із заявок.</p>}
              </ul>
            </div>
          </Aux>
        );
        break;
      case ('money-requests'):
        inputElement = (
          <Aux>
            <Button
              btnType='Success'
              clicked={(ev) => this.props.extraAction.calculateWeight(ev)}
              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}>
              ПРИСВОИТЬ ВЕС ЗАЯВКЕ
            </Button>
            <table className={classes.Table}>
              <th>Номер</th>
              <th>Дата</th>
              <th>Клиент</th>
              <th>Адрес</th>
              <th>Вес</th>
              {
                this.props.value ? this.props.value.map(moneyRequest => (
                  <tr>
                    <td>{moneyRequest.numberZk}</td>
                    <td>{this.formatDate(moneyRequest.dateZk)}</td>
                    <td>{moneyRequest.client}</td>
                    <td>{moneyRequest.address}</td>
                    <td>{moneyRequest.weight}</td>
                  </tr>
                ))
                  : null
              }
              <tr>
                <td><strong>Всего:</strong></td>
                <td></td>
                <td></td>
                <td></td>
                <td><strong>{
                  this.props.value ?
                    roundNum(this.props.value.reduce((a, b) => a + (b.weight || 0), 0))
                    : null}</strong></td>
              </tr>
            </table>
          </Aux>
        );
        break;
      case ('managersEdit'):
        inputElement = (
          <Aux>
            <div
              className={inputClasses.join(' ')}
              style={{ width: "100%" }}>
              <ul className={classes.ListNoBullet}>
                <li className={[classes.ListNoBulletElement, classes.ListNoBulletHeading].join(' ')}>
                  <p style={{ width: "40%", wordBreak: "break-all" }}>Менеджер</p>
                  <p style={{ width: "15%" }}>Telegram ID</p>
                  <p style={{ width: "25%" }}>Telegram Chat ID</p>
                  <p style={{ width: "20%" }}>Kanban Аккаунт</p>
                </li>
                {this.props.value.length > 0 ?
                  this.props.value.map((element, index) => {
                    return (
                      <li
                        className={[classes.Option, classes.ListNoBulletElement].join(' ')}
                        key={index}>
                        <p style={{ width: "30%" }}>
                          {element.name}
                        </p>
                        <ButtonIcon
                          btnType='Success'
                          clicked={(ev) => this.props.extraAction.editManagerPreferences(ev, index)}
                          iconClass={classes.ButtonIcon}
                          iconSource={openImg}
                          small
                          style={{ width: "auto", maxWidth: "10%", padding: "5px", borderRadius: "5px", display: "inline-block", marginLeft: "5px" }}
                          iconAlt=''></ButtonIcon>
                        <input
                          type="number"
                          placeholder="Телеграм ID"
                          value={element.tbotId}
                          style={{ width: "15%" }}
                          onChange={(ev) => changeManagerTbot(ev, index)}
                          className={[classes.InputElement, classes.InputElementInline].join(' ')} />
                        <select
                          style={{ width: "12.5%" }}
                          className={[classes.InputElement, classes.InputElementInline].join(' ')}
                          value={element.tbotChatId}
                          onChange={(ev) => chatManagerChat(ev, index)} >
                          {this.props.elementConfig.options.length > 0 ?
                            this.props.elementConfig.options.map((option, index) => {
                              return (
                                <option key={index} value={option.value}>
                                  {option.displayValue}
                                </option>
                              )
                            })
                            : null}
                        </select>
                        <input
                          type="number"
                          placeholder="Телеграм Чат ID"
                          value={element.tbotChatId}
                          onChange={(ev) => chatManagerChat(ev, index)}
                          style={{ width: "12.5%" }}
                          className={[classes.InputElement, classes.InputElementInline].join(' ')} />
                        <select
                          className={[classes.InputElement, classes.InputElementInline].join(' ')}
                          value={element.username}
                          style={{ width: "20%" }}
                          onChange={(ev) => changeManagerUser(ev, index)} >
                          {this.props.elementConfig.usernames.length > 0 ?
                            this.props.elementConfig.usernames.map((username, index) => {
                              return (
                                <option key={index} value={username}>
                                  {username}
                                </option>
                              )
                            })
                            : null}
                        </select>
                      </li>
                    );
                  }) : <p className={classes.EmptyList}>Нет менеджеров.</p>}
              </ul>
            </div>
          </Aux>
        );
        break;
      case ('requests'):
        inputElement = (
          <div
            className={inputClasses.join(' ')}
            style={{ padding: "0", width: "100%" }}>
            <ul className={classes.ListNoBullet}>
              <li className={[classes.ListNoBulletElement, classes.ListNoBulletHeading].join(' ')}>
                <ButtonIcon
                  btnType={this.props.elementConfig.editing ? 'Neutral' : 'Success'}
                  clicked={(ev) => this.props.extraAction.editing(ev)}
                  iconClass={classes.ButtonIcon}
                  iconSource={editImg}
                  small
                  style={{ width: "auto", maxWidth: "7.5%", padding: "5px", borderRadius: "5px", float: "right", display: "inline-block", marginLeft: "5px" }}
                  iconAlt=''></ButtonIcon>
                <ButtonIcon
                  btnType={'Success'}
                  clicked={(ev) => this.props.extraAction.merge(ev)}
                  iconClass={classes.ButtonIcon}
                  iconSource={mergeImg}
                  small
                  style={{ width: "auto", maxWidth: "7.5%", padding: "5px", borderRadius: "5px", float: "right", display: "inline-block", marginLeft: "5px" }}
                  iconAlt=''></ButtonIcon>
                <p style={{ width: "5%" }}> № </p>
                <p style={{ width: "20%" }}> Менеджер </p>
                <p style={{ width: "10%" }}> Заявлено </p>
                <p style={{ width: "10%", wordBreak: "break-all" }}> Заявлено Мані </p>
                <p style={{ width: "37.5%" }}> Вивантаження </p>
                <p style={{ width: "5%" }}> Ід </p>
              </li>
              {
                Object.keys(this.props.value).sort((a, b) => a - b).map((key, indexOutter) => {
                  if (this.props.value[key].length === 0) {
                    return (
                      <li
                        className={[classes.Option, classes.ListNoBulletElement, key === '0' ? classes.RequestNoOrder : null].join(' ')}>
                        <p style={{ width: "5%", paddingLeft: "5px" }}>{key}</p>
                        <p style={{ padding: "5px 10px 5px 10px" }}>Невизначене Сортування</p>
                        {
                          this.props.elementConfig.editing &&
                          <ButtonIcon
                            btnType='Danger'
                            clicked={(ev) => this.props.extraAction.deleteSorting(ev, key)}
                            btnClass={classes.EditRequest1}
                            iconClass={classes.ButtonIcon}
                            iconSource={deleteImg}
                            small
                            style={{ width: "auto", maxWidth: "7.5%", padding: "5px", borderRadius: "5px", float: "right", display: "inline-block", marginLeft: "5px" }}
                            iconAlt=''></ButtonIcon>
                        }
                      </li>
                    );
                  }

                  let homogenous = [];
                  for (let i = 0; i < this.props.value[key].length; i++) {
                    if (!homogenous.includes(this.props.value[key][i].destination)) {
                      homogenous.push(this.props.value[key][i].destination);
                    }
                  }

                  let max = Object.keys(this.props.value).length - 1;

                  return (
                    <li
                      className={[
                        classes.Option,
                        classes.ListNoBulletElement,
                        homogenous.length >= 2 ? classes.RequestManyDestinations : null,
                        key === '0' ? classes.RequestNoOrder : null].join(' ')}
                      key={indexOutter}>
                      {
                        this.props.value[key].length > 0 && key !== '0' &&
                        <div style={{ textTransform: "uppercase" }}><strong>{this.props.value[key][0].destination}</strong></div>
                      }
                      {
                        this.props.value[key].map((element, indexInner) => {
                          return (
                            <div className={classes.Option}>
                              {
                                this.props.elementConfig.editing ?
                                  <Aux>
                                    <ButtonIcon
                                      btnType='Success'
                                      clicked={(ev) => this.props.extraAction.createSortingDown(ev, key, indexInner)}
                                      btnClass={classes.EditRequest1}
                                      iconClass={classes.ButtonIcon}
                                      iconSource={arrowDownPlusImg}
                                      small
                                      style={{ width: "auto", maxWidth: "7.5%", padding: "5px", borderRadius: "5px", float: "right", display: "inline-block", marginLeft: "5px" }}
                                      iconAlt=''></ButtonIcon>
                                    <ButtonIcon
                                      btnType='Success'
                                      disabled={key === '0'}
                                      clicked={(ev) => this.props.extraAction.createSortingUp(ev, key, indexInner)}
                                      btnClass={classes.EditRequest2}
                                      iconClass={classes.ButtonIcon}
                                      iconSource={arrowUpPlusImg}
                                      small
                                      style={{ width: "auto", maxWidth: "7.5%", padding: "5px", borderRadius: "5px", float: "right", display: "inline-block", marginLeft: "5px" }}
                                      iconAlt=''></ButtonIcon>
                                    <ButtonIcon
                                      btnType='Success'
                                      clicked={(ev) => this.props.extraAction.moveSortingDown(ev, key, indexInner)}
                                      btnClass={classes.EditRequest3}
                                      iconClass={classes.ButtonIcon}
                                      iconSource={arrowImg}
                                      disabled={indexOutter === max}
                                      small
                                      style={{ width: "auto", maxWidth: "7.5%", padding: "5px", borderRadius: "5px", float: "right", display: "inline-block", marginLeft: "5px" }}
                                      iconAlt=''></ButtonIcon>
                                    <ButtonIcon
                                      btnType='Success'
                                      disabled={key === '0'}
                                      btnClass={classes.EditRequest4}
                                      clicked={(ev) => this.props.extraAction.moveSortingUp(ev, key, indexInner)}
                                      iconClass={classes.ButtonIcon}
                                      iconSource={arrowUpImg}
                                      small
                                      style={{ width: "auto", maxWidth: "7.5%", padding: "5px", borderRadius: "5px", float: "right", display: "inline-block", marginLeft: "5px" }}
                                      iconAlt=''></ButtonIcon>
                                  </Aux>
                                  :
                                  <ButtonIcon
                                    btnType='Success'
                                    clicked={(ev) => this.props.extraAction.openRequest(ev, key, indexInner)}
                                    iconClass={classes.ButtonIcon}
                                    btnClass={classes.EditRequest1}
                                    iconSource={openImg}
                                    small
                                    style={{ width: "auto", maxWidth: "7.5%", padding: "5px", borderRadius: "5px", float: "right", display: "inline-block", marginLeft: "5px" }}
                                    iconAlt=''></ButtonIcon>
                              }
                              {
                                this.props.elementConfig.editing ?
                                  <input
                                    type="number"
                                    style={{ width: "5%", maxWidth: "5%" }}
                                    onChange={(ev) => this.props.extraAction.changeSorting(ev, key, indexInner)}
                                    value={element.sorting} /> :
                                  <p style={{ width: "5%" }}>{element.sorting}</p>
                              }
                              <p style={{ width: "20%", wordBreak: "break-all", paddingLeft: "5px" }}>{element.manager}</p>
                              <input
                                type="number"
                                step="0.01"
                                min="0.1"
                                placeholder="Заявлено"
                                value={roundNum(element.load)}
                                onChange={(ev) => changedLoadLocal(ev, key, indexInner)}
                                className={[classes.InputElement, classes.InputElementInline].join(' ')}
                                style={{ width: "10%", margin: "0" }} />
                              <input
                                type="text"
                                disabled
                                placeholder="Заявлено (Мани)"
                                value={
                                  element.moneyRequests ?
                                    roundNum(element.moneyRequests.reduce((a, b) => a + (b.weight || 0), 0)) + " (" + roundNum(element.load - element.moneyRequests.reduce((a, b) => a + (b.weight || 0), 0)) + ")" :
                                    "N/A"}
                                className={[classes.InputElement, classes.InputElementInline, classes.InputDisabled].join(' ')}
                                style={{ width: "10%", margin: "0" }} />
                              <div
                                className={classes.Unloading}
                                style={{ width: this.props.elementConfig.editing ? "30%" : "37.5%", margin: "0", paddingLeft: "5px", wordBreak: "break-all" }} >
                                {element.origin} в {element.destination}: {element.unloading}
                              </div>
                              <p style={{ width: "5%" }}>{getId(element.id)}</p>
                            </div>
                          )
                        })
                      }
                    </li>
                  );
                })}
            </ul>
          </div>
        );
        break;
      case ('locations'):
        inputElement = (
          <div
            className={inputClasses.join(' ')}>
            <ul>
              {this.props.value.map((element, index) => (
                <li
                  key={index}
                  className={classes.Option}>
                  <input
                    key={index}
                    type="text"
                    placeholder="Локация"
                    value={element.location}
                    onChange={(ev) => locationChanged(ev, index)}
                    className={[classes.InputElement, classes.InputElementInline].join(' ')} />
                  <select
                    className={[classes.InputElement, classes.InputElementInline].join(' ')}
                    value={element.region}
                    onChange={(ev) => regionChanged(ev, index)} >
                    <option key="Львов" value={1}>
                      Львов
                    </option>
                    <option key="Винница" value={2}>
                      Винница
                    </option>
                    <option key="Киев" value={3}>
                      Киев
                    </option>
                    <option key="Харьков" value={4}>
                      Харьков
                    </option>
                    <option key="Днепр" value={5}>
                      Днепр
                    </option>
                    <option key="Одесса" value={6}>
                      Одесса
                    </option>
                    <option key="Импорт" value={7}>
                      Импорт
                    </option>
                  </select>
                  <label className={classes.Switch}>
                    <input
                      type="checkbox"
                      checked={element.originatingLocation}
                      onChange={(ev) => originatingLocationChanged(ev, index)}
                      className={[classes.SwitchInput, classes.SliderInput, classes.Round].join(' ')} />
                    <span className={classes.Slider}></span>
                  </label>
                  <button
                    className={classes.CloseButtonInline}
                    onClick={(ev) => removeFromArray(ev, element)}>
                    <Icon iconClass={classes.CloseIconSmall} iconSource={closeImg} iconAlt='' />
                  </button>
                </li>
              ))}
            </ul>
            <Button
              btnType='Success'
              clicked={(ev) => addLocation(ev)}>
              ДОБАВИТЬ
            </Button>
          </div>
        );
        break;
      case ('users'):
        inputElement = (
          <div
            className={inputClasses.join(' ')}
            style={{ width: "100%" }}>
            <ul className={classes.ListNoBullet}>
              <ButtonIcon
                btnType='Success'
                clicked={(ev) => copyToClipboard(ev, "all-users", "Скопировал почты пользователей.")}
                iconClass={classes.ButtonIcon}
                iconSource={copyImg}
                small
                style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                iconAlt=''></ButtonIcon>
              <textarea
                style={{ verticalAlign: "middle" }}
                id="all-users"
                value={this.props.value.map(element => element.email).join(',')}></textarea>
              <li>
                <p style={{ width: "30%", paddingLeft: "10px" }}>Пользователь</p>
                <p style={{ width: "20%", paddingLeft: "10px" }}>Роль</p>
                <p style={{ width: "10%", paddingLeft: "10px" }}>Бан</p>
                <p style={{ width: "20%", paddingLeft: "10px" }}>Астериск</p>
                <p style={{ width: "20%", paddingLeft: "10px" }}>МиниАТС</p>
              </li>
              {this.props.value.map((element, index) => {
                return (
                  <li
                    className={[classes.ListNoBulletElement, classes.ListNoBulletHeading].join(' ')}
                    key={index + " " + element.email} >
                    <div
                      style={{ width: "30%", display: "inline-block" }}>
                      <input
                        type="text"
                        value={element.email}
                        disabled
                        className={[classes.InputElement, classes.InputElementInline].join(' ')}
                        style={{ width: "100%" }} />
                    </div>
                    <div
                      style={{ width: "20%", display: "inline-block" }}>
                      <select
                        className={[classes.InputElement, classes.InputElementInline].join(' ')}
                        value={element.role}
                        style={{ width: "100%" }}
                        onChange={(ev) => userRoleChanged(ev, index)} >
                        <option key="USER" value={1}>
                          Пользователь
                        </option>
                        <option key="DISPATCHER" value={2}>
                          Диспетчер
                        </option>
                        <option key="MANAGER" value={3}>
                          Менеджер
                        </option>
                        <option key="ADMIN" value={4}>
                          Админ
                        </option>
                        <option key="RULER" value={5}>
                          Руководитель
                        </option>
                      </select>
                    </div>
                    <div
                      style={{ width: "10%", display: "inline-block" }}>
                      <label
                        className={classes.Switch}
                        style={{ maxWidth: "100%" }} >
                        <input
                          type="checkbox"
                          checked={element.locked}
                          onChange={(ev) => accountLockedChanged(ev, index)}
                          className={[classes.SwitchInput, classes.SliderInput, classes.Round].join(' ')} />
                        <span className={classes.Slider}></span>
                      </label>
                    </div>
                    <div
                      style={{ width: "20%", display: "inline-block" }}>
                      <input
                        key={index + "ast"}
                        type="text"
                        placeholder="Астериск"
                        value={element.asteriskId}
                        onChange={(ev) => changeAsteriskId(ev, index)}
                        className={[classes.InputElement, classes.InputElementInline].join(' ')}
                        style={{ width: "100%" }} />
                    </div>
                    <div
                      style={{ width: "20%", display: "inline-block" }}>
                      <input
                        key={index + "miniast"}
                        type="text"
                        placeholder="МиниАТС"
                        value={element.miniAsterisk}
                        onChange={(ev) => changeMiniAsterisk(ev, index)}
                        className={[classes.InputElement, classes.InputElementInline].join(' ')}
                        style={{ width: "100%" }} />
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        );
        break;
      default:
        inputElement = <input
          className={inputClasses.join(' ')}
          {...this.props.elementConfig}
          value={this.props.value}
          onChange={this.props.changed} />;
    }

    let divClass = [classes.Input];
    if (this.props.extraClass) {
      divClass.push(this.props.extraClass);
    }

    let labelClass = [classes.Label];
    if (this.props.elementType === 'display-only') {
      labelClass.push(classes.LabelInline);
    }
    if (this.props.elementConfig.labelClass) {
      labelClass.push(this.props.elementConfig.labelClass);
    }

    let label = <label className={labelClass.join(' ')} >{this.props.label}</label>;
    if (this.props.label === "") {
      label = null;
    }
    if (this.props.elementType === "carriers") {
      let actionButtons = null;
      if (this.props.role === 'ROLE_ADMIN' || this.props.role === 'ROLE_DISPATCHER') {
        if (this.props.value !== null && this.props.value !== '' && this.props.value !== "-") {
          actionButtons = (
            <Aux>
              <ButtonIcon
                btnType='Success'
                clicked={(ev) => this.props.extraAction.new(ev)}
                iconClass={classes.ButtonIcon}
                iconSource={addPersonImg}
                small
                style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                iconAlt=''></ButtonIcon>
              <ButtonIcon
                btnType='Success'
                clicked={(ev) => this.props.extraAction.edit(ev)}
                iconClass={classes.ButtonIcon}
                iconSource={editImg}
                small
                style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                iconAlt=''></ButtonIcon>
              <ButtonIconConfirm
                btnType='Danger'
                clicked={(ev) => this.props.extraAction.del(ev)}
                iconClass={classes.ButtonIcon}
                iconSource={deleteImg}
                small
                confirmText="удалить Перевозчика"
                style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
                iconAlt=''></ButtonIconConfirm>
            </Aux>
          );
        } else {
          actionButtons = (
            <ButtonIcon
              btnType='Success'
              clicked={(ev) => this.props.extraAction.new(ev)}
              iconClass={classes.ButtonIcon}
              iconSource={addPersonImg}
              small
              style={{ width: "auto", display: "inline-block", marginLeft: "5px" }}
              iconAlt=''></ButtonIcon>
          );
        }
      }
      label = (<Aux>
        <label className={labelClass.join(' ')} style={{ display: "inline-block" }} >
          {this.props.label}
        </label>
        {actionButtons}
      </Aux>);
    }

    return (
      <div
        className={divClass.join(' ')}>
        {label}
        {inputElement}
        {validationError}
      </div>
    );
  }
};

const mapStateToProps = state => {
  return {
    carriers: state.carriers,
    role: state.role,
    locations: state.locations
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Input);



// WEBPACK FOOTER //
// ./src/components/UI/Input/Input.js